import {registerSingleton} from "@/services/GlobalContext";
import Events from "@/services/Events";
import {renderSlot} from "vue";

class SessionManager{
    constructor() {
        this.userData = null;
        this.initialized = false;
        this.pendings = [];

        window.addEventListener(Events.userData, e => {
            this.initialized = true;
            this.userData = e.detail?.userData ?? null;
            this.pendings.forEach(p => {
                try {
                    p(this.userData);
                } catch (e){
                    console.error(e);
                }
            });
        });
    }

    async getUserData(){
        return new Promise(resolve => {
           if(this.initialized){
               resolve(this.userData);
           }  else {
               this.pendings.push(resolve);
           }
        });
    }
}

/** @type SessionManager*/
const sessionManager = registerSingleton("SessionManager", () => {
    return new SessionManager();
});

export default sessionManager;
